export const MAX_CHALLENGES = 8;
export const ALERT_TIME_MS = 2000;
export const REVEAL_TIME_MS = 350;
export const GAME_LOST_INFO_DELAY = REVEAL_TIME_MS;
export const WELCOME_INFO_MODAL_MS = 350;
